<template>

<v-simple-table class="mb-4">
<template v-slot:default>
  <thead v-if="!nohead">
    <tr>
      <th v-for="cell in arr[0]" class="text-left"> {{ cell }} </th>
    </tr>
  </thead>
  <tbody>
    <tr
      v-for="row in (nohead ? arr : arr.slice(1))"
      :key="row[0]"
    >
      <td v-for="cell in row"> {{ cell }} </td>
    </tr>
  </tbody>
</template>
</v-simple-table>

</template>

<script>

export default {
	components: {},
	props: {
		nohead: Boolean,
		arr: Array
	},
	data() {
		return {

		}
	},
	methods: {

	},
	created() {

	}
}
</script>
